import {UsanaObject} from "../usana-object";
import {UrlService} from "../common/url.service";
import {LoggerService} from "../common/logger.service";
import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {Observable, throwError} from "rxjs";
import {IAd} from "./landing.models";
import {IFeaturedProductsView, IProduct} from "../product/product-models";
import {IMarketingPage} from "../marketing-pages/marketing-page.models";
import {TranslateService} from "../translation/translate.service";
import {Constants} from "../constants";

@Injectable({
    providedIn: 'root'
})
export class LandingService extends UsanaObject {

    constructor(
        loggerService: LoggerService,
        private http: HttpClient,
        private urlService: UrlService,
        private translateService: TranslateService
    ) {
        super(loggerService);
    }

    getLandingAd(locale: string,type: string): Observable<IAd[]> {
        const options = {
            ...(this.translateService.alternateLocaleSubject.isPresent() && {headers: new HttpHeaders({[Constants.LOCALE_OVERRIDE_HEADER]: this.translateService.alternateLocaleSubject.get().usanaLocale})})
        };
        return this.http.get(this.urlService.buildCartUrl("ad/current?Locale=" + locale + "&Type=" + type), options).pipe(
            map((response: IAd[]) => response),
            catchError((error: any) => throwError(error))
        );
    }

    getLandingProducts(): Observable<IProduct[]> {
        return this.http.get(this.urlService.buildCartUrl("featuredProductList/landing/")).pipe(
            map((response: IProduct[])=> response),
            catchError((error: any) => throwError(error))
        );
    }

    getLandingFeaturedProducts(): Observable<IFeaturedProductsView> {
        return this.http.get(this.urlService.buildCartUrl("featuredProductList/landingProducts")).pipe(
            map((response: IFeaturedProductsView) => response),
            catchError((error: any) => throwError(error))
        );
    }

    getLandingPage(): Observable<IMarketingPage> {
        return this.http.get(this.urlService.buildCartUrl("/pages/landing")).pipe(
            map((response: IMarketingPage) => response),
            catchError((error: any) => throwError(error))
        );
    }

}
